import {
  ScaffolderFormHeader,
  ScaffolderFormPaper,
} from '@internal/plugin-scaffolder-common-field-react';
import React, { useEffect, useRef } from 'react';

import { SourcePicker } from '../components/SourcePicker';
import { SOURCE_INFO } from '../infoDoc';
import { SourceConfiguration } from '../types';

interface ApplicationSetSourceSectionProps {
  value: SourceConfiguration | null;
  onChange: (value: SourceConfiguration | null) => void;
  errors: string[];
}

const ApplicationSetSourceSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSetSourceSectionProps) => {
  const hasErrors = errors.length > 0;
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasErrors) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [hasErrors]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <ScaffolderFormHeader
          title="Source"
          description="Configure the source for this ApplicationSet's deployment."
          divider
          infoDoc={SOURCE_INFO}
        />
        <SourcePicker
          value={value}
          onChange={onChange}
          errors={errors}
          enableAppSetSupport
        />
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSetSourceSection = React.memo(
  ApplicationSetSourceSectionInner,
);
